import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import { Stack, Divider, AppBar, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useFinanceContext } from 'src/components/plaid/datasource';
import Scrollbar from 'src/components/scrollbar';
import AddGoalRowForm from './add-goal-form-row';
import { GoalRow } from './goal-row';

export default function GoalsEditor({ onCancel }) {
  const {
    goalService: { goals: persistedGoals, save },
  } = useFinanceContext();

  const [goals, setGoals] = useState([]);
  const [expand, setExpand] = useState(false);
  const [loading, setLoading] = useState(false);

  // Compare the arrays and find changed objects
  const isChanged = !_.isEqual(persistedGoals, goals);

  useEffect(() => setGoals(persistedGoals), [persistedGoals]);

  // write the new key assumptions to the db
  const saveChanges = async () => {
    try {
      setLoading(true);
      console.log({ goals });
      await save(goals);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onDiscardChanges = () => (isChanged ? setGoals(persistedGoals) : onCancel());
  const onGoalChanged = (category, value) => setGoals((prev) => ({ ...prev, [category]: value }));
  const onDeleteGoal = async (category) => {
    setGoals((prev) => {
      const updatedGoals = { ...prev };
      delete updatedGoals[category];
      return updatedGoals;
    });
  };

  // Render the budget changes
  const renderGoals = () => (
    <Stack spacing={1} padding={2}>
      <AddGoalRowForm {...{ expand, setExpand }} />
      <Divider />
      {Object.entries(goals ?? {})?.map(([category, amount], index) => (
        <GoalRow
          key={category ?? index}
          value={{ category, amount }}
          onChange={onGoalChanged}
          onDelete={onDeleteGoal}
        />
      ))}
    </Stack>
  );

  return (
    <>
      <Scrollbar sx={{ height: '90dvh' }}>{renderGoals()}</Scrollbar>
      {!expand && (
        <AppBar position="sticky">
          <Stack spacing={1} sx={{ p: 2, bottom: 0, left: 0, right: 0 }}>
            <LoadingButton
              loading={loading}
              variant="contained"
              size="large"
              fullWidth
              color="success"
              disabled={!isChanged}
              onClick={saveChanges}
            >
              Save Changes
            </LoadingButton>
            <Button onClick={onDiscardChanges}>Cancel</Button>
          </Stack>
        </AppBar>
      )}
    </>
  );
}
